// Returns the value of the cookie with the given name
const getTrackingCookieValue = (name) => {
    var match = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"));
    if (match) return match[2];
};

export default getTrackingCookieValue;
